import {configure} from 'mobx'

//State can be changed from anywhere
configure({enforceActions: 'never'})
